import {Constants} from "../constants/constants";

export const initialState = {
    total: 0
};

export default function webCheckout(state = initialState, action) {
    switch (action.type) {
        case Constants.WEB_CHECKOUT_UPDATE:
            return { ...state, total: action.total }
        default:
            return state
    }
}
